import { ProductTour } from './ProductTour';
import { DASHBOARD_TOUR_STEPS } from './dashboard-tour';
import { useProductTour } from './useProductTour';

/**
 * Mounts the first-run dashboard tour inside the owner shell. Skipping or
 * finishing both persist the flag — the tour never re-opens on its own
 * (replay via the Guide page).
 */
export function ProductTourHost() {
  const { open, markDone } = useProductTour();

  return <ProductTour steps={DASHBOARD_TOUR_STEPS} open={open} onClose={markDone} />;
}
